
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedPublishedComment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anonUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"byAllocator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentCreationTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentObject"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedEmployerProfile"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedIdea"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedPost"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedWhitePaper"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedIdeaUpdate"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedUser"},"directives":[]}]}}]}}],"loc":{"start":0,"end":638}};
    doc.loc.source = {"body":"#import './ActivityFeedAdminPost.graphql'\n#import './ActivityFeedEmployerProfile.graphql'\n#import './ActivityFeedIdea.graphql'\n#import './ActivityFeedIdeaUpdate.graphql'\n#import './ActivityFeedPost.graphql'\n#import './ActivityFeedUser.graphql'\n#import './ActivityFeedWhitePaper.graphql'\n\nfragment ActivityFeedPublishedComment on Comment {\n  id\n  anonUser {\n    id\n    title\n    username\n  }\n  body\n  byAllocator\n  commentCreationTime\n  commentObject {\n    ...ActivityFeedEmployerProfile\n    ...ActivityFeedIdea\n    ...ActivityFeedPost\n    ...ActivityFeedWhitePaper\n    ...ActivityFeedIdeaUpdate\n  }\n  user {\n    ...ActivityFeedUser\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedAdminPost.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedEmployerProfile.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedIdea.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedIdeaUpdate.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedPost.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedUser.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedWhitePaper.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ActivityFeedPublishedComment"] = oneQuery(doc, "ActivityFeedPublishedComment");
        
